{
  "version": "2.4.26",
  "build": 324,
  "date": "2026-05-25"
}
